export const enum MessageChannel {
  /**
   * 系统消息
   */
  SYSTEM = "system",
  /**
   * 幸福快讯
   */
  HAPPY_NEWS = "happy_news",
  WENTI_NEWS = "wenti_news",
  // "notify_message",
  MessageGroupTrend = "community_message",
  MessageGroupTrendAudit = "trend_audit", //动态审核
}
export const enum CommunityChannel {
  COMMUNITY_COMMENT = "community_comment", //评论
  COMMUNITY_FOCUS = "community_focus", //关注
  COMMUNITY_LIKE = "community_like", //点赞
  COMMUNITY_NOTICE = "community_notice", //通知
}
export const CommunityArr = [
  "community_comment",
  "community_focus",
  "community_like",
  "community_notice",
];
export interface MessageItem {
  userMessageId: string;
  userId: string;
  messageCode: string;
  messageTitle: string;
  columnId: MessageChannel;
  messageDesc: string;
  infoLink?: string; // 消息链接
  hasContent: "Y" | "N"; // 是否有内容
  sendTime: string;
  messageContent?: string;
}
// 站内信内置 小分类category类型
export enum MessageCategory {
  MessageCategoryNotifyRecruitJob = "notify_recruit_job", // 通知-职位相关通知
  MessageCategoryNotifyApplyFeedback = "notify_apply_feedback", // 通知-企业收到的 求职者反馈
  MessageCategoryNotifyCompany = "notify_company", // 通知-单位收到的消息
  MessageCategoryNotifyRecruitSynergy = "notify_recruit_synergy", // 通知-招聘协作
  MessageCategoryNotifyActivity = "notify_activity", // 通知-活动通知
  MessageCategoryTrendComment = "1", // 动态-评论
  MessageCategoryTrendLikeCollect = "2", // 动态-点赞
  MessageCategoryTrendFollow = "3", // 动态-新增关注
  MessageCategoryTrendNotice = "4", // 动态-通知
}

// 站内信消息内置 Type类型
export enum MessageType {
  MessageTypeAdminPush = "admin_push", // 后台推送
  // MessageGroupNotify-MessageCategoryNotifyRecruitJob
  MessageTypeJobAuditPass = "job_audit_pass", // 职位审核通过-点击后跳转职位详情页面
  MessageTypeJobAuditFailed = "job_audit_failed", // 职位审核不通过-点击后新页面打开该职位编辑页
  MessageTypeJobOfflineDay = "job_offline_day", // 职位day天后下线-点击后直接定位到职位管理-在线中tab页
  MessageTypeJobOffline = "job_offline", // 职位下线-点击后跳转至简历管理页面
  MessageTypeApplyView = "apply_view", // 简历查看提醒-点击后跳转至简历管理页面

  // MessageGroupReport
  MessageTypeJobReport = "job_report", // 职位举报-点击后跳转至B端职位列表-审核不通过tab页

  // MessageGroupNotify-MessageCategoryNotifyApplyFeedback
  MessageTypeApplyFeedback = "apply_feedback", // 候选人反馈

  // MessageGroupNotify-MessageCategoryNotifyCompany
  MessageTypeCompanyMediaFailed = "company_media_audit_failed", // 单位风采审核未通过-点击后跳转到招聘设置-单位风采的页面
  MessageTypeCompanyVerificationPass = "company_verification_pass", // 单位认证资料通过-点击后跳转至对应单位的主页
  MessageTypeCompanyVerificationFailed = "company_verification_failed", // 单位认证资料不通过-点击后跳转至对应单位认证的修改基本信息页
  MessageTypeCompanyOrganizationRemove = "company_organization_remove", // 组织机构调整（删除）-点击后跳转至对应单位的组织机构编辑页
  MessageTypeCompanyOrganizationAdd = "company_organization_add", // 组织机构调整（添加）-点击后跳转至对应单位的组织机构编辑页
  MessageTypeCompanyInfoAuditPass = "company_info_pass", // 单位资料审核通过-点击后跳转单位主页
  MessageTypeCompanyInfoAuditFailed = "company_info_failed", // 单位资料审核不通过-点击后跳转单位主页
  MessageTypeCompanyQualificationRemind = "company_qualification_remind", // 资质临期提醒。

  // MessageGroupNotify-MessageCategoryNotifyRecruitSynergy
  MessageTypeJoinCompanyAddSelf = "join_company_add_self", // 您已加入单位
  MessageTypeJoinCompanyAddOffsider = "join_company_add_offsider", // 同事加入单位
  MessageTypeJoinCompanyRemoveSelf = "join_company_remove_self", // 您已被移出单位
  MessageTypeJoinCompanyRemoveOffsider = "join_company_remove_offsider", // 同事被移出单位
  MessageTypeRestoreAdminSelf = "restore_admin_self", // 恢复本人管理员身份
  MessageTypeRestoreAdminOffsider = "restore_admin_offsider", // 恢复同事管理员身份
  MessageTypeCompanySuperEdit = "company_senior_edit", // 把你设置为主管理员
  MessageTypeCompanySetSuper = "company_set_senior", // 被设置为主管理员-点击跳转对应单位的招聘设置页面
  MessageTypeCompanyAdminHanoverHeir = "company_admin_hanover_heir", // 交接管理员

  //
  MessageTypeApplyEvolve = "apply_evolve", // 简历最新进展

  // MessageGroupSystem
  MessageTypeVerificationPass = "verification_pass", // 实名认证审核通过
  MessageTypeVerificationFailed = "verification_failed", // 实名认证审核不通过-点击后跳转到实名认证信息填报页面
  MessageTypeAspirationApplyFailed = "aspiration_apply_failed", // 志愿投递失败-点击后跳转个人投递记录

  // MessageGroupReport
  MessageTypeJobReportJobFeedback = "job_report_job_feedback", // 职位举报处理结果-职位
  MessageTypeJobReportUserFeedback = "job_report_user_feedback", // 职位举报处理结果-企业
  MessageTypeJobReportChatFeedback = "job_report_chat_feedback", // 职位举报处理结果-群聊

  // MessageGroupNotify-MessageCategoryNotifyActivity（通知-活动通知）
  MessageTypeInterchoiceStart = "interchoice_start",
  MessageTypeInterchoiceEnd = "interchoice_end",
  MessageTypeInterchoiceIntention = "interchoice_intention",
  // 宣讲会
  MessageTypeConferenceStart = "conference_start",

  // 社区动态
  MessageTypeTrendAudit = "trend_audit", // 社区动态审核

  // 直播间
  MessageTypeLiveStart = "live_session_start", // 直播开始
}

export enum TrendMessageType {
  AuditSuccess = 1,
  AuditFail,
  Like,
  LikeComment,
  LikeReply,
  Collect,
  Comment,
  Reply,
  Report,
}

// 投递简历的状态
export const enum ProcessStatus {
  // 待筛选
  SELECTING = "selecting",
  // 第三方链接渲染
  THIRD_INFO = "third_info", // 在待筛选状态中返回
  // 简历已被查看
  CHECKED = "checked",
  // 初筛通过
  SELECTED = "selected",
  // 笔试
  EXAM = "exam",
  // 笔试成绩
  EXAM_SCORE = "exam_score",
  // 面试环节
  INTERVIEW = "interview",
  // 面试成绩
  INTERVIEW_SCORE = "interview_score",
  // 拟录用
  EMPLOYMENT = "employ", // 拟录用
  // 不合格
  ELIMINATE = "eliminate", // 不合格
  // 简历退回
  REFUND = "refund",
  // 系统通知
  SYSTEM_NOTICE = "system_notice",
}

/**
 * 应聘反馈
 */
export interface FeedbackItem {
  id: string;
  company_id: string;
  company_name: string;
  apply_id: string;
  job_name: string;
  user_process: ProcessStatus;
  user_process_name: string;
  is_read: boolean;
  read_time: string;
  feedback_time: string;
  feedback: FeedbackBtnStatus; // 0 不需要反馈  1未反馈 2 接收 3拒绝
  im_process_name: string;
  content: {
    exam_address: string;
    exam_time: string;
    exam_type: string;
    others: string;
    show_type?: string;
    text?: string;
  };
  create_time: string;
  reply?: string;
  need_custom_reply?: boolean;
  deadline_time?: string;
}
/**
 * 应聘反馈的反馈状态
 */
export const enum FeedbackBtnStatus {
  NOT_NEED = 0, // 不需要反馈
  PENDING, // 等待反馈
  CONFIRMED, // 已确认
  REJECTED, // 已拒绝
  TIMEOUT, // 超时
}

/**
 * 反馈详情的内容名称映射
 */
export const FeedbackDetailName: any = {
  exam_time: "笔试时间",
  exam_type: "笔试类型",
  exam_address: "笔试地址",
  score: "笔试成绩",
  exam_score: "笔试成绩",
  interview_score: "面试成绩",
  overall_score: "综合成绩",
  exam_threshold_score: "应聘岗位的入围面试分数线",
  interview_threshold_score: "应聘岗位的入围考察与体检分数线",
  others: "其他说明",
  interview_time: "面试时间",
  interview_type: "面试类型",
  interview_address: "面试地址",
  employ_time: "拟入职时间",
  employ_address: "入职报道地址",
  eliminate: "应聘进展",
  checked: "应聘进展",
  refund_reason: "退回原因",
  feedback_text: "应聘进展",
  selected: "应聘进展",
};

/**
 * 消息中心中的动态的评论反馈
 * @see https://console-docs.apipost.cn/preview/7760fcf0a084069f/2c363683bee3e793?target_id=12266203-2e29-49cc-9b6a-c296419a2872
 */
export interface MessageTrendItem {
  messageId: string;
  trendsId: string;
  commentsId: string;
  replyId?: any;
  trendsType: number;
  privacySetting?: any;
  trendsTitle?: string | null;
  trendsContent?: any;
  trendsCoverImageUrl?: string;
  trendsCreateTime?: string;
  auditResult?: string;
  auditReason?: string;
  messageType: number;
  messageTypeDesc: string;
  appId: string;
  fromUserId: string;
  fromUserIdentity: string;
  fromUserNickname: string;
  fromUserOrgId?: string;
  fromUserOrgName?: string;
  fromUserOrgNickname?: string;
  fromUserOrgAuth?: "Y" | "N"; // 发送方机构认证Y认证N未认证
  fromUserAvatar: string;
  fromUserProfessionalGuide?: "Y" | "N"; // 发送方职场伯主认证Y认证N未认证
  fromUserBoleLevel?: any;
  toUserId: string;
  toUserIdentity: string;
  toUserNickname: string;
  trendsCoverImage?: any;
  pushTime: string;
  eventTime: string;
  readTime?: any;
  bizParams: string;
  fromUserComment: string | null;
  fromUserCommentId: string | null;
  fromUserReply?: string;
  fromUserReplyId: string;
  fromUserCommentEmojiName?: string; //收到的评论表情
  fromUserReplyEmojiName?: string; // 收到的回复表情
  toUserReplyCommentId?: string | null;
  toUserReplyCommentUserId?: string | null;
  toUserReplyCommentUserIdentity?: string | null;
  toUserReplyCommentUserNickName?: string | null;
  toUserReplyComment?: any;
  toUserComment?: any;
  toUserCommentId?: any;
  fromTrendsAuthorFlag?: "Y" | "N"; // 发送方是不是动态作者Y是，N否
  meLike?: 0 | 1; // 我是否已点赞1-是0-否
  trendsUserIdentity: string;
  trendsUserId: string;
  trendsNickName: string;
  fromUserReplyContent?: any;
  toUserReplyId?: any;
  toUserReply?: any;
  reportId?: any;
  reportPublishUserId?: any;
  reportPublishUserIdentity?: any;
  reportPublishUserNickName?: any;
  reportBizType?: any;
  reportContent?: any;
  reportPhone?: any;
  reportEmail?: any;
  reportOtherContacts?: any;
  reportType?: any;
  reportRemark?: any;
  reportAuditStatus?: any;
  reportTrendsId?: string;
  reportCommentId?: string;
  reportReplyId?: string;
  isAuthor: boolean; // 是否是作者
  fromDel: "0" | "1"; // 评论状态：0存在，1的话代表删除
  toDel: "0" | "1"; // 评论状态：0存在，1的话代表删除
  fromUserCommentFileIds: string[]; // 动态评论文件id集合
  fromUserReplyFileIds: string[]; // 动态回复文件id集合
  fromUserBigVipFlag?: BigVipFlag; // 是否有V标识（0：没有，1：有）
}

export const enum BigVipFlag {
  YES = "1",
  NO = "0",
}
